import * as yup from 'yup';

import { NestedOption } from '~/core/shared/types/utility';
import { INCOMPLETE_NESTED_OPTION_MESSAGE } from '../constants/incompleteNestedOptionMessage';
import { isNestedOptionLeafPath } from './isNestedOptionLeafPath';

/**
 * Takes nullable and required string schemas alike, and hands back the same schema type so the
 * caller's own modifiers survive.
 */
export const assertNestedOptionLeaf = <
  StringSchema extends yup.StringSchema<
    yup.Maybe<string>,
    yup.AnyObject,
    unknown,
    yup.Flags
  >,
>(
  schema: StringSchema,
  options: readonly NestedOption[] | undefined,
): StringSchema =>
  schema.test(
    'nested-option-leaf',
    INCOMPLETE_NESTED_OPTION_MESSAGE,
    (value) => !value || !options || isNestedOptionLeafPath(options, value),
  );
